import { withRouter } from 'react-router-dom'

import { compose, createSink, onlyUpdateForKeys } from 'recompose'

import { APP_VERSION, USER_EMAIL } from 'app-constants'
import withPartnerProps from 'components/HOCs/WithPartnerProps'
import defaults from 'components/Trackers/defaults'
import { getPageViewEvent } from 'utils/analytics'
import { sendToSentry } from 'utils/errors'
import { withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getFunnelName } from 'utils/FlowProvider/utils'
import { withOptimizely } from 'utils/Optimizely'
import withTieredRegistration from 'utils/TieredRegistration'

import trackEvent from './trackEvent'
import { getSourceAttributes } from './utils'

export type EventData = {
  object_name: string
  screen: string
  screen_name: string
}

const enhance = compose(
  withOptimizely,
  withFlowRouter,
  withRouter,
  withPartnerProps,
  withTieredRegistration,
  onlyUpdateForKeys(['location', 'partner', 'tierPrice']),
)
const trackPageViewed = ({
  location,
  trackOptimizely,
  flow,
  isPartnerReg,
  partner,
  tierPrice,
  isEarlyTier,
}) => {
  if (!isPartnerReg || (isPartnerReg && partner !== null)) {
    try {
      let eventData = getPageViewEvent(location, flow) as EventData
      const partnerName = partner?.org?.name ?? null

      // Used for tracking the success screen viewed for Early accounts
      if (isEarlyTier && location.pathname === FlowRoute.Success && flow === 'tiered') {
        eventData = { ...eventData, object_name: 'registrationSuccessEarlyTier' }
      }

      // For consistency with mobile, we send Page Views as tracked screen view events
      trackEvent('Screen Viewed', {
        eventData: {
          ...defaults('Screen Viewed'),
          ...eventData,
          tierPrice,
          sourceAttributes: getSourceAttributes({ flow, location, partner }),
        },
        flow,
        partner,
      })

      window.dataLayer.push({
        event: 'Screen Viewed',
        funnel: getFunnelName(flow),
        funnel_pathname: window.location.pathname,
        email: window.sessionStorage.getItem(USER_EMAIL),
      })

      window.analytics.page({
        app_version: APP_VERSION,
        url: window.location.href,
        partner: partnerName,
        funnel: getFunnelName(flow),
        tierPrice,
      })

      trackOptimizely(`${eventData.screen}.screen_viewed`)
    } catch (error) {
      sendToSentry(error, { name: 'TrackPageViewedError', extras: { pathname: location.pathname } })
    }
  }
}

export default enhance(createSink(trackPageViewed))
